<template>
		
	<v-treeview fill-height
		:style="`font-size:15px;`"
		ref="contentTree"
		v-model="treeModel"
		
		:open.sync="treeOpenNodes"
		:active.sync="treeActiveItem"

		:items="treeItems"
		activatable
		item-key="id"
		item-text="editorMetaData.treeNodeLabel"
		hoverable
		dense
		class="treeCompactNodes grey lighten-4 ma-0 pa-0 overflow-y-auto"
	>
		<template v-slot:prepend="{ item }"><!-- , open -->
			<div class="ai-highlight-top" style="visibility: hidden; width: 100%; height: 6px; background: #000000; position: absolute; left: 0px; top: -3px; pointer-events: none; opacity: 0;"/>
			<div class="ai-highlight-middle" style="visibility: hidden; width: 100%; height: 30px; background: #000000; position: absolute; left: 0px; top: 3px; pointer-events: none; opacity: 0;"/>
			<div class="ai-highlight-bottom" style="visibility: hidden; width: 100%; height: 6px; background: #000000; position: absolute; left: 0px; top: 33px; pointer-events: none; opacity: 0;"/>
			<!-- <v-icon v-if="item.folder === true" style="font-size: 22px">
				{{ item.treeIcon }}
			</v-icon>
			<v-icon v-else>{{ nodeTypes[item.nodeType] }}</v-icon> -->
			
			<v-icon style="font-size: 22px" v-if="item.nodeType === 'shared-content'" color="#3e578a">{{ item.treeIcon }}</v-icon>
            <v-icon style="font-size: 22px" v-else>{{ item.treeIcon }}</v-icon>

			<div class="ai-id" :treeName="treeName" :id="item.id" :isfolder="item.folder === true"/>
		</template>
	</v-treeview>
</template>


<script>

// ----------------------------------------------------
//  Main script
// ----------------------------------------------------

import fb from '@/shift/fb';
import agile from '@/shift/agile';
//import agileFb from "@/shift/agileFb";
import { AiEventBus } from '@/main';
import { TweenMax } from "gsap/all";



export default
{
	name: 'ContentEditorTree',

	props:
	{
		/* height:
		{
			type: Number
		}, */

		/* openPageTypeEdit:
		{
			type: Function
		}, */

	},


	data: () =>
	({
		treeName: 'contentTree',
		//height: 100,
		nodeTypes: {
			page: "mdi-page-next-outline",
		},

		treeOpenNodes: [],
		treeActiveItem: [],
		treeModel: [],

		treeItems: [],
		treeOrphans: [],
		
		windowSize:
		{
			x: 0,
			y: 0
		},

		navigation:
		{
			shown: false,
			width: 200,
			borderSize: 3
		},

		trackedTreeNodes: [],

		isDragging: '',
		isDraggingOffsetY: 0,

		hasInitializedUserSync: false,
		allowUserSync: true,
		boundOnResize: null,
		preventTreeActiveItemLoop: false,

	}),

	computed:
	{
		routeKey()
		{
			return this.$route.params.key;
		},

		appBarHeight()
		{
			return agile.appBarHeight();
		},

		toolBarPrimaryHeight()
		{
			return agile.toolBarPrimaryHeight();
		},

		toolBarSecondaryHeight()
		{
			return agile.toolBarSecondaryHeight();
		},
	},

	watch:
	{
		treeItems()
		{
			//console.log("tree change");

		},
		
		treeModel()
		{
			//console.log("tree change");

		},

		treeActiveItem()
		{	
			if (!this.preventTreeActiveItemLoop)
			{
				const showId = (this.treeActiveItem[0]) ? this.treeActiveItem[0] : '' ;
				this.$parent.$parent.activeTreeNodeId = (showId) ? 'Id: '+showId : '';
				
				// Make sure the other shared content tree is unselected when we select in this
				this.$parent.$parent.$refs.sharedTreeComponent.resetTreeActiveItem();
				

				if (showId)
				{
					this.$parent.$parent.activeTreeNodeType = agile.getObjectById(this.treeItems, showId).editorMetaData.templateName;
				}
				else
				{
					this.$parent.$parent.activeTreeNodeType = '';
				}
			}
		},

		treeOpenNodes()
		{
			// We want to save the folders open/closed state for you the user
			if (agile.loggedInUser.uid && this.hasInitializedUserSync && this.allowUserSync)
			{
				
				// We don't want to spam the firestore database, wait atleast 1 second before we update, and block other requests to sync
				this.allowUserSync = false;
				const scopeThis = this;

				setTimeout(function()
				{
					scopeThis.allowUserSync = true;

					if (scopeThis.treeOpenNodes !== undefined)
					{
						const saveStateData =
						{
							contentEditorTreeState: scopeThis.treeOpenNodes,
						}
						
						// Ok, do the sync command
						fb.db.collection("users").doc(agile.loggedInUser.uid).collection("saved-states").doc(scopeThis.routeKey).set(saveStateData, { merge: true })
						.then(() =>
						{
							//console.log("Updated tree open state", scopeThis.treeOpenNodes);
						})
						.catch((error) =>
						{
							console.log('Error syncronizing user tree state:', error.message);
						});
					}

				}, 1000);

				
			}

			// Every time we open a folder node, we need to update the nested children with listeners for drag and drop
			// Also when closing, we need to dispose of now unused nodes. Wait one millisecond to wait for Vuetify to update
			setTimeout(this.updateTreeDrag, 1);
		},
		
	},

	created()
	{
		this.boundOnResize = this.onResize.bind(this)
		window.addEventListener('resize', this.boundOnResize);
	},

	mounted()
	{
		this.onResize();
	},

	methods:
	{
		resetTreeActiveItem()
		{
			this.preventTreeActiveItemLoop = true;
			this.treeActiveItem = [];
			setTimeout(() =>
			{
				this.preventTreeActiveItemLoop = false;
			}, 500);
		},

		// --------------------------------------------------------------------
		//
		//	Update the tree's drag and drop capabilities. Vuetify v-tree-view
		//	does not support drag and drop. We fix this by manually detecting and 
		//	injecting the DOM of the tree, and then use native JS drag and drop.
		//	We then post changes to the Firestore and then update the tree based
		//	on live updates from Firebase and feed into the dataprovider of the tree.
		//
		// --------------------------------------------------------------------

		updateTreeDrag()
		{
			const visibleTreeNodes = this.$refs.contentTree.$el.getElementsByClassName('v-treeview-node__root');

			for (let i = 0; i < visibleTreeNodes.length; i++)
			{
				// Check if we have registred this node before
				let found = false;

				for (let j = 0; j < this.trackedTreeNodes.length; j++)
				{
					if (visibleTreeNodes[i] === this.trackedTreeNodes[j])
					{
						found = true;
						break;
					}
				}

				if (!found)
				{
					// If this is a new node, then we register it and add listener
					this.trackedTreeNodes.push(visibleTreeNodes[i]);
					//this.treeName = 'contentTree';

					// Turn off pointer events for the content child nodes (icon, label, etc.) in the node, because it
					// creates a mess with the dragenter/leave events.
					const nodeContent = visibleTreeNodes[i].getElementsByClassName('v-treeview-node__content')[0];
					nodeContent.style.pointerEvents = 'none';

					this.addDragAndDropListeners(visibleTreeNodes[i]);

					//console.log('New node', visibleTreeNodes[i]);
				}
			}

			// Find orphaned nodes (typical nodes in folders that are closed, or deleted)
			for (let i = this.trackedTreeNodes.length-1; i >= 0; i--)
			{
				let foundInTree = false;

				for (let j = 0; j < visibleTreeNodes.length; j++)
				{
					if (visibleTreeNodes[j] === this.trackedTreeNodes[i])
					{
						foundInTree = true;
						break;
					}
				}

				// If the node is found in tree, then it is alive and kicking. If not
				// found, it is an orphan and needs to be removed.
				if (!foundInTree)
				{
					// Orphan node found, remove listeners and remove it from array
					this.removeDragAndDropListeners(this.trackedTreeNodes[i]);
					this.trackedTreeNodes.splice(i, 1);
				}
			}

		},
		

		// --------------------------------------------------------------------
		//
		//	Add and remove drag and drop listeners (and double click)
		//
		// --------------------------------------------------------------------

		addDragAndDropListeners(target)
		{
			if (target.dragListenersAdded) return;
			target.dragListenersAdded = true;

			//  Listen to double click
			target.addEventListener('dblclick', this.onDoubleClick);

			//  Listen to start drag
			target.addEventListener('mousedown', this.startDrag);
			
			//  Listen to when the actual drag starts
			target.addEventListener('dragstart', this.startedDrag);

			//  Listen to drop
			target.addEventListener('drop', this.onDrop, false);

			//  Prevent some default js behaviour
			['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
				target.addEventListener(eventName, agile.preventDefaults, false);
			});

			//  Add highlighting when dragging item over
			['dragenter', 'dragover'].forEach(eventName =>
			{
				target.addEventListener(eventName, this.addDropTargetHighlights, false);
			});

			// Remove highlighting when dragging item over
			['dragleave', 'drop'].forEach(eventName =>
			{
				target.addEventListener(eventName, this.removeDropTargetHighlights, false);
			});
		},

		removeDragAndDropListeners(target)
		{
			if (!target.dragListenersAdded) return;
			target.dragListenersAdded = false;

			target.removeEventListener('dblclick', this.onDoubleClick);
			target.removeEventListener('mousedown', this.startDrag);
			target.removeEventListener('dragstart', this.startedDrag);
			target.removeEventListener('drop', this.onDrop, false);

			['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
				target.removeEventListener(eventName, agile.preventDefaults, false);
			});

			['dragenter', 'dragover'].forEach(eventName =>
			{
				target.removeEventListener(eventName, this.addDropTargetHighlights, false);
			});

			['dragleave', 'drop'].forEach(eventName =>
			{
				target.removeEventListener(eventName, this.removeDropTargetHighlights, false);
			});
		},


		// --------------------------------------------------------------------
		//
		//	Drag and drop listeners (and double click)
		//
		// --------------------------------------------------------------------
		
		onDoubleClick(e)
		{	
			const el = e.currentTarget.getElementsByClassName('ai-id')[0];
			const id = el.id;
			
			AiEventBus.$emit('contentEditorOpenDocument', id);//agile.getObjectById(this.treeItems, id));
		},


		startDrag(e)
		{
			if (!agile.loggedInUser.superAdmin) return;

			const id = e.currentTarget.getElementsByClassName('ai-id')[0].id;
			const target = agile.getObjectById(this.treeItems, id);

			// For now, we don't want to let users rearrange internal shared content nodes in the content tree
			// Exception of course for the shared content root, that can be relocated anywhere.
			if (target.sharedContent === true && target.sharedRootId !== 'sharedRoot') return;
			
			e.currentTarget.draggable = true;
			
			this.isDragging = id;
			this.isDraggingOffsetY = e.offsetY; // Remember the offset, so we can position the drop more precicely
		},

		startedDrag(e)
		{
			const id = e.currentTarget.getElementsByClassName('ai-id')[0].id;
			const dataString = `{ "id": "${id}", "treeName": "${this.treeName}" }`;
			e.dataTransfer.setData('text/plain', dataString);
		},



		// --------------------------------------------------------------------
		//
		//	THE BIG DROP!!!
		//	Here we drop shared content into the main content tree.
		//	Lots of checking and crap.
		//
		// --------------------------------------------------------------------

		onDrop(e)
		{
			
			// Get id of drop target
			let incoming = null; try { incoming = JSON.parse(e.dataTransfer.getData('text')); } catch (er) { /**/ }
			e.dataTransfer.clearData();
			if (!incoming) return; // We don't know whats dropping here.. go away now!
			const el = e.currentTarget.getElementsByClassName('ai-id')[0];
			const id = el.id;
			if (incoming.id === id) return; // For some reason the drag and the drop are the same
			
			const isFolder = el.getAttribute('isfolder') === 'true';
			const localDrop = (incoming.treeName === this.treeName);
			const incomingItem = agile.getObjectById( (localDrop) ? this.treeItems : this.$parent.$parent.$refs.sharedTreeComponent.treeItems , incoming.id);
			if (!localDrop && incomingItem.nodeType !== 'shared-content') return; // Make sure the incoming alien drop actually is a shared content object (and not i.e. sorting folder)
			if (!localDrop && incomingItem.parentItem.nodeType === 'shared-content') return; // We only accept the root node from shared content, not the child nodes of shared content!!!

			const dropZone = agile.getObjectById(this.treeItems, id);

			let denyDirectDrop = false;
			if (dropZone.nodeType === 'shared-content' && incomingItem.nodeType === 'shared-content')
			{
				// Don't drop shared content into shared content!!
				// Exception is when we want to drag root shared content above or below each other.
				if (dropZone.sharedRootId === 'sharedRoot' && incomingItem.sharedRootId === 'sharedRoot')
				{
					denyDirectDrop = true;
				}
				else
				{
					return;
				}
				
			}

			// ------------------------------------------------
			//	Ok, lets do stuff
			// ------------------------------------------------

			// Getting strange values with offsetY ~^
			const useY = e.pageY-e.currentTarget.getBoundingClientRect().top-this.isDraggingOffsetY;

			if (useY < -12) // Move above
			{
				if (localDrop)
				{
					this.rearrangeNode(this.isDragging, id, true);
				}
				else
				{
					this.addSharedNodeBeside(incomingItem, id, true);
				}
			}
			else if (useY > 12) // Move below
			{
				if (localDrop)
				{
					this.rearrangeNode(this.isDragging, id, false);
				}
				else
				{
					this.addSharedNodeBeside(incomingItem, id, false);
				}
			}
			else // Nest inside
			{
				if (!denyDirectDrop)
				{
					if (localDrop)
					{
						if (isFolder) this.relocateNode(this.isDragging, id);
					}
					else
					{
						if (isFolder) this.addSharedNodeInside(incomingItem, id);
					}
				}
				
			}

			
			

		},
		
		addDropTargetHighlights(e)
		{
			const el = e.currentTarget.getElementsByClassName('ai-id')[0];
			const id = el.id;
			const isFolder = el.getAttribute('isfolder') === 'true';
			
			if (this.isDragging === id) return;
			
			const top = e.currentTarget.getElementsByClassName('ai-highlight-top')[0];
			const middle = e.currentTarget.getElementsByClassName('ai-highlight-middle')[0];
			const bottom = e.currentTarget.getElementsByClassName('ai-highlight-bottom')[0];

			// Getting strange values with offsetY ~^
			const useY = e.pageY-e.currentTarget.getBoundingClientRect().top-this.isDraggingOffsetY;

			if (useY < -12) // Move above
			{
				TweenMax.to(top, 0.5, { autoAlpha:0.2, overwrite:true });
				TweenMax.to(middle, 0.3, { autoAlpha:0, overwrite:true });
				TweenMax.to(bottom, 0.3, { autoAlpha:0, overwrite:true });
			}
			else if (useY > 12) // Move below
			{
				TweenMax.to(top, 0.3, { autoAlpha:0, overwrite:true });
				TweenMax.to(middle, 0.3, { autoAlpha:0, overwrite:true });
				TweenMax.to(bottom, 0.5, { autoAlpha:0.2, overwrite:true });
			}
			else // Nest inside
			{
				TweenMax.to(top, 0.3, { autoAlpha:0, overwrite:true });
				if (isFolder) TweenMax.to(middle, 0.5, { autoAlpha:0.2, overwrite:true });
				TweenMax.to(bottom, 0.3, { autoAlpha:0, overwrite:true });
			}

		},


		removeDropTargetHighlights(e)
		{
			const top = e.currentTarget.getElementsByClassName('ai-highlight-top')[0];
			const middle = e.currentTarget.getElementsByClassName('ai-highlight-middle')[0];
			const bottom = e.currentTarget.getElementsByClassName('ai-highlight-bottom')[0];

			TweenMax.to(top, 0.3, { autoAlpha:0, overwrite:true });
			TweenMax.to(middle, 0.3, { autoAlpha:0, overwrite:true });
			TweenMax.to(bottom, 0.3, { autoAlpha:0, overwrite:true });

		},





		// --------------------------------------------------------------------
		//
		//	Drag and drop operation, here we nest a node in a folder
		//
		// --------------------------------------------------------------------


		relocateNode(idToMove, moveToId)
		{
			if (idToMove === moveToId) return; // Can't drop on yourself :o
			
			//const objectToDrop = agile.getObjectById(this.treeItems, idToMove);
			const dropToObject = agile.getObjectById(this.treeItems, moveToId);

			if (dropToObject && dropToObject.parentItem)
			{
				// Check if use is not dragging the folder to it's own subfolder
				let isAncestor = false;
				let pi = dropToObject.parentItem;
				while (pi !== 'root' || !pi)
				{
					if (pi.id === idToMove)
					{
						isAncestor = true;
						break;
					}
					pi = pi.parentItem;
				}
				
				if (isAncestor)
				{
					return
					//this.$root.$alert('Wrong move', 'Can not nest inside its own folder');
				}
				
				// Open the folder we are moving into
				if (!this.treeOpenNodes.includes(moveToId)) this.treeOpenNodes.push(moveToId);
				
				const updateData =
				{
					editorMetaData:
					{
						treeNodePosition: dropToObject.children.length,
						treeNodeParent: moveToId
					}
				};

				this.updateItemToFirestore(updateData, idToMove);
				
			}
			
		},


		// --------------------------------------------------------------------
		//
		//	Drag and drop operation, we place a node above or below some other node
		//
		// --------------------------------------------------------------------

		rearrangeNode(idToMove, _moveToId, _above) // if 'above' is false, then it is re-ordered below
		{
			let above = _above;
			let moveToId = _moveToId;
			if (idToMove === moveToId) return; // Makes no sense to move above or below yourself...
			
			// ----------------------------------
			//	Get new order sorted
			// ----------------------------------

			const objectDropping = agile.getObjectById(this.treeItems, idToMove);
			let moveToArray = agile.getObjectParentArrayById(this.treeItems, moveToId);

			// If we are dropping "below" a folder node that is open, then we actually want to place
			// the node inside it, and at index 0.
			if (!above)
			{
				for (let i = 0; i < this.treeOpenNodes.length; i++)
				{
					if (this.treeOpenNodes[i] === moveToId)
					{
						const moveToObject = agile.getObjectById(this.treeItems, moveToId);
						if (moveToObject.children && moveToObject.children.length > 0)
						{
							// Ok, so, when we try to move "below" an open folder, we change the placement
							// to be the "above" the first node in the folder!
							moveToArray = moveToObject.children;
							moveToId = moveToObject.children[0].id;
							above = true;
						}
						break;
					}
				}
				
			}
			

			// Check if use is not dragging the folder to it selft as subfolder
			let isAncestor = false;
			let pi = moveToArray[0].parentItem;
			while (pi !== 'root' || !pi)
			{
				if (pi.id === idToMove)
				{
					isAncestor = true;
					break;
				}
				pi = pi.parentItem;
			}
			
			if (isAncestor)
			{
				//this.$root.$alert('Wrong move', 'Can not nest inside its own folder');
			}
			else
			{
				// Also be aware, we might not only be arranging sort order of node
				// but may be dragging into a completely different parent node as well
				const moveToParentId = agile.getObjectParentIdByChildId(this.treeItems, moveToId);
				const newOrder = [];

				for (let i = 0; i < moveToArray.length; i++)
				{
					if (moveToArray[i].id === moveToId)
					{
						if (above) newOrder.push( { id: idToMove, nodeType: objectDropping.nodeType } );
						newOrder.push( { id: moveToArray[i].id, nodeType: moveToArray[i].nodeType } );
						if (!above) newOrder.push( { id: idToMove, nodeType: objectDropping.nodeType } );
					}
					// If the id of item we are moving are already in same array (which
					// is very likely), we do not append that twice (we already did above)
					else if (moveToArray[i].id !== idToMove)
					{
						newOrder.push( { id: moveToArray[i].id, nodeType: moveToArray[i].nodeType } );
					}
				}


				// ----------------------------------
				//	Get started with firebase op
				// ----------------------------------

				const collection = fb.db
					.collection('content-collection')
					.doc('content-doc')
					.collection(this.routeKey)
					.doc(this.routeKey)
					.collection('content');

				//Todo: Batch commands only supports max 500 batch jobs. Bigger structures will fail, so we need to queue them.
				const batch = fb.db.batch();
				
				for (let i = 0; i < newOrder.length; i++)
				{
					batch.set(collection.doc(newOrder[i].id),
					{
						editorMetaData:
						{
							treeNodePosition: i,
							treeNodeParent: moveToParentId
						}
					}, { merge: true });
				}

				// ----------------------------------
				//	Do the update
				// ----------------------------------

				batch.commit()
				.then(() =>
				{
					//console.log("* Updated tree sort order");
				})
				.catch((error) =>
				{
					this.$root.$alert("Error", error.message);
				});
			}

		},




		// --------------------------------------------------------------------
		//
		//	Shared content drag into tree operations
		//
		// --------------------------------------------------------------------

		addSharedNodeInside(sharedSourceObject, moveToId)
		{
			if (sharedSourceObject.id === moveToId) return; // Can't drop on yourself :o
			
			const dropToObject = agile.getObjectById(this.treeItems, moveToId);

			if (dropToObject/*  && dropToObject.parentItem */) // Not sure why I have parentItem as check here before?
			{
				
				// Open the folder we are moving into
				if (!this.treeOpenNodes.includes(moveToId)) this.treeOpenNodes.push(moveToId);	///////////////////////////// NOT WORKING
				
				const sharedStructureArray = [];
				agile.collectObjectsAsIdParentArray(sharedSourceObject, sharedStructureArray, moveToId);
				this.keepAddingSharedStructure(sharedStructureArray, dropToObject.children.length, 'sharedRoot', moveToId);
				this.$root.ai_app.showProgressWheel = true;
			}
			
		},


		keepAddingSharedStructure(sharedArray, nodePosition, sharedRootId, parentId = null)
		{
			// Setup command
			const collection = fb.db
				.collection('content-collection')
				.doc('content-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection('content');

									/* visibility: 'draft',
									trash: false,
									sharedContent: true,
									sharedRootId: setSharedRootId,
									originalId: docRef.id,

									editorMetaData:
									{
										treeNodeLabel: returnData.createdName,
										treeNodeParent: parentNodeId,
										treeNodePosition: 99999,
										templateName: returnData.docData.name,
										templateId: returnData.docData.id,
									},

									contentMetaData: returnData.docData.data.settings, */


			collection.add(
			{
				// --------------------------------------------------------------------
				//																					!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
				//	Adding of Shared content to Main content is happening right here!				!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
				//																					!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
				// --------------------------------------------------------------------

				visibility: 'draft',
				trash: false,
				sharedContent: true,
				sharedRootId: sharedRootId,
				originalId: sharedArray[0].id,

				editorMetaData:
				{
					treeNodeLabel: sharedArray[0].editorMetaData.treeNodeLabel,
					// We only need 'parentId' argument for the very first node that are attached to the existing tree
					// After that, we access the already given parent ID
					treeNodeParent: (parentId) ? parentId : sharedArray[0].parentItem.newSharedId,
					treeNodePosition: nodePosition,
					templateName: sharedArray[0].editorMetaData.templateName,
					templateId: sharedArray[0].editorMetaData.templateId,
				},

				contentMetaData: sharedArray[0].contentMetaData,

				/* name: sharedArray[0].name,
				sharedContent: true,
				sharedRootId: sharedRootId,
				originalId: sharedArray[0].id,
				contentType: sharedArray[0].contentType,
				contentTypeId: sharedArray[0].contentTypeId,
				buildingState: sharedArray[0].buildingState,
				visibility: sharedArray[0].visibility,
				trash: false,
				editorMetaData:
				{
					// We only need 'parentId' argument for the very first node that are attached to the existing tree
					// After that, we access the already given parent ID
					treeNodeParent: (parentId) ? parentId : sharedArray[0].parentItem.newSharedId,
					treeNodePosition: nodePosition,
				},
				settings: sharedArray[0].settings, */
			})
			.then((docRef) =>
			{
				sharedArray[0].newSharedId = docRef.id;
				if (sharedRootId === 'sharedRoot') sharedRootId = docRef.id;
				
				if (sharedArray.length > 1)
				{
					sharedArray.shift();
					this.keepAddingSharedStructure(sharedArray, sharedArray[0].editorMetaData.treeNodePosition, sharedRootId);
				}
				else
				{
					// Just completely empty the array when we are done
					this.$root.ai_app.showProgressWheel = false;
					sharedArray.shift();
				}
			})
			.catch((error) =>
			{
				console.log('Error adding shared content:', sharedArray[0].editorMetaData.treeNodeLabel, error.message);
				this.$root.ai_app.showProgressWheel = false;
			});

			
		},





		// --------------------------------------------------------------------
		//
		//	Drag and drop operation, we place a node above or below some other node
		//
		// --------------------------------------------------------------------

		addSharedNodeBeside(objectDropping, _moveToId, _above) // if 'above' is false, then it is re-ordered below
		{
			let above = _above;
			let moveToId = _moveToId;
			if (objectDropping.id === moveToId) return; // Makes no sense to move above or below yourself...
			
			// ----------------------------------
			//	Get new order sorted
			// ----------------------------------

			let moveToArray = agile.getObjectParentArrayById(this.treeItems, moveToId);

			// If we are dropping "below" a folder node that is open, then we actually want to place
			// the node inside it, and at index 0.
			if (!above)
			{
				for (let i = 0; i < this.treeOpenNodes.length; i++)
				{
					if (this.treeOpenNodes[i] === moveToId)
					{
						const moveToObject = agile.getObjectById(this.treeItems, moveToId);
						if (moveToObject.children && moveToObject.children.length > 0)
						{
							// Ok, so, when we try to move "below" an open folder, we change the placement
							// to be the "above" the first node in the folder!
							moveToArray = moveToObject.children;
							moveToId = moveToObject.children[0].id;
							above = true;
						}
						break;
					}
				}
				
			}
			

			
			// Also be aware, we might not only be arranging sort order of node
			// but may be dragging into a completely different parent node as well
			const moveToParentId = agile.getObjectParentIdByChildId(this.treeItems, moveToId);
			const newOrder = [];

			for (let i = 0; i < moveToArray.length; i++)
			{
				if (moveToArray[i].id === moveToId)
				{
					if (above) newOrder.push( { id: objectDropping.id, nodeType: objectDropping.nodeType } );
					newOrder.push( { id: moveToArray[i].id, nodeType: moveToArray[i].nodeType } );
					if (!above) newOrder.push( { id: objectDropping.id, nodeType: objectDropping.nodeType } );
				}
				// If the id of item we are moving are already in same array (which
				// is very likely), we do not append that twice (we already did above)
				else if (moveToArray[i].id !== objectDropping.id)
				{
					newOrder.push( { id: moveToArray[i].id, nodeType: moveToArray[i].nodeType } );
				}
			}


			// ----------------------------------
			//	Update the positions on the existing
			//	siblings in the tree node list
			// ----------------------------------

			const collection = fb.db
				.collection('content-collection')
				.doc('content-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection('content');

			//Todo: Batch commands only supports max 500 batch jobs. Bigger structures will fail, so we need to queue them.
			const batch = fb.db.batch();
			
			let rememberNewSharedPosition;

			for (let i = 0; i < newOrder.length; i++)
			{
				// Remember, the shared content node we are putting in here, does not exist in the normal content yet
				if (newOrder[i].id !== objectDropping.id)
				{
					batch.set(collection.doc(newOrder[i].id),
					{
						editorMetaData:
						{
							treeNodePosition: i,
							treeNodeParent: moveToParentId
						}
					}, { merge: true });
				}
				else
				{
					rememberNewSharedPosition = i;
				}
			}

			
			

			// Prepare shared content to be added

			const sharedStructureArray = [];
			agile.collectObjectsAsIdParentArray(objectDropping, sharedStructureArray, moveToId);
			
			
			// ----------------------------------------------------
			//	Do the update to existing normal content first
			// ----------------------------------------------------
			
			this.$root.ai_app.showProgressWheel = true;

			batch.commit()
			.then(() =>
			{
				//console.log("* Updated tree sort order before adding shared content");

				// ----------------------------------------------------
				//	Then we add the shared content to content tree
				// ----------------------------------------------------
				this.keepAddingSharedStructure(sharedStructureArray, rememberNewSharedPosition, 'sharedRoot', moveToParentId);

			})
			.catch((error) =>
			{
				this.$root.$alert("Error", error.message);
			});
			

		},













		// ----------------------------------
		//	Update command for firestore
		// ----------------------------------

		updateItemToFirestore(thingsToUpdate, id)
		{
			// Setup command
			const collection = fb.db
				.collection('content-collection')
				.doc('content-doc')
				.collection(this.routeKey)
				.doc(this.routeKey)
				.collection('content');

			
			collection.doc(id).set(thingsToUpdate, { merge: true })
			.then(() =>
			{
				//console.log("Updated");
			})
			.catch((error) =>
			{
				console.log('Error updating:', error.message);
			});
		},

		onResize()
		{
			const treeView = this.$refs.contentTree.$el;

			const computedfillHeight =
				window.innerHeight-
				this.appBarHeight-
				(this.toolBarPrimaryHeight*2)-
				this.toolBarSecondaryHeight;
			
			treeView; computedfillHeight;
			//treeView.style.height = (computedfillHeight/2) + "px";
		},






		// --------------------------------------------------------------------
		//
		//	Build dataprovider for treeview, with nodes supplied live from Firestore!
		//
		// --------------------------------------------------------------------

		insertInTree(item)
		{
			if (!item.editorMetaData.treeNodeParent) item.editorMetaData.treeNodeParent = 'root'; // if item has no parent, make root it's parent
			
			if (item.editorMetaData.treeNodeParent === 'root')
			{
				item.parentItem = 'root';
				this.treeItems.push(item);
			}
			else
			{				
				const parent = agile.getObjectById(this.treeItems, item.editorMetaData.treeNodeParent);
				
				// We have no idea in which order we are receiving the tree items, so parent nodes might not
				// be built yet.
				if (parent)
				{
					
					// If we find the parent, store the item there
					if (!parent.children) // Parent doesnt accept children, put the node to root instead as safety solution
					{
						item.parentItem = 'root';
						this.treeItems.push(item);
					}
					else
					{
						
						item.parentItem = parent;
						parent.children.push(item);
					}
					
				}
				else
				{
					// If not, store it in orphans, and we will see if we find parent later
					this.treeOrphans.push(item);
				}
				
			}


			// Now check the orphans. Maybe our new item is parent to some orphaned item
			for (let i = this.treeOrphans.length-1; i >= 0; i--)
			{
				if (this.treeOrphans[i].editorMetaData.treeNodeParent === item.id)
				{
					if (!item.children)
					{
						console.log(`* Tree builder is trying to add treenode to parent that has no "children" object. Adding to root instead (${this.treeOrphans[i].editorMetaData.treeNodeLabel}).`);
						this.treeOrphans[i].parentItem = 'root';
						this.treeItems.push(this.treeOrphans[i]);
					}
					else
					{
						this.treeOrphans[i].parentItem = item;
						item.children.push(this.treeOrphans[i]);
					}

					// Ok, we have sorted that this is not an orphan anymore, take it out of orphan list
					this.treeOrphans.splice(i, 1);
				}
			}


			// Now we really check on behalf of the orphans. Do they have parents or not?

			let lastCount = 0;
			let currentCount = this.treeOrphans.length;

			while (lastCount !== currentCount) // Check until there are no possible parents for orphans
			{
				for (let i = this.treeOrphans.length-1; i >= 0; i--)
				{
					const checkItem = this.treeOrphans[i];
					const checkItemParent = agile.getObjectById(this.treeItems, checkItem.editorMetaData.treeNodeParent);
					
					

					if (checkItemParent)
					{
						// If we find the parent, store the item there
						if (!checkItemParent.children) // Parent doesnt accept children, put the node to root instead as safety solution
						{
							checkItem.parentItem = 'root';
							this.treeItems.push(checkItem);
						}
						else
						{		
							checkItem.parentItem = checkItemParent;
							checkItemParent.children.push(checkItem);
						}
						this.treeOrphans.splice(i, 1);
					}
				}

				//console.log(lastCount, currentCount);

				lastCount = currentCount;
				currentCount = this.treeOrphans.length;
			}




			// Update sort order
			// It seems a bit excessive to update the whole tree just because we added one or a few items? But maybe it is not so hard to process, who knows...
			agile.updateTreeSortOrder(this.treeItems, this.treeOpenNodes);
			
			// Update tree
			// We need to tick one before we go go
			setTimeout(this.updateTreeDrag, 1);
		},




		// --------------------------------------------------------------------
		//
		//	Update treeview dataprovider, after we get live data from firestore
		//
		// --------------------------------------------------------------------

		updateTreeItem(dataItem)
		{
			let updateItem = agile.getObjectById(this.treeItems, dataItem.id);


			if (!updateItem)
			{
				console.log("Update item is not good! (updateTreeItem)", updateItem)
			}
			else
			{
				// Lets update data
				updateItem.editorMetaData.treeNodeLabel = dataItem.editorMetaData.treeNodeLabel;
				updateItem.editorMetaData.treeNodePosition = dataItem.editorMetaData.treeNodePosition;
				
				if (updateItem.editorMetaData.treeNodeParent != dataItem.editorMetaData.treeNodeParent)
				{
					updateItem.editorMetaData.treeNodeParent = dataItem.editorMetaData.treeNodeParent;

					// Parent is changed, we need to remove item from tree
					updateItem = agile.getAndRemoveObjectById(this.treeItems, dataItem.id);

					const scopeThis = this;
					const tempActives = this.treeOpenNodes.slice();

					setTimeout(function()
					{
						if (!updateItem.editorMetaData.treeNodeParent) updateItem.editorMetaData.treeNodeParent = 'root';

						// Replace item
						if (updateItem.editorMetaData.treeNodeParent === 'root')
						{
							updateItem.parentItem = 'root';
							scopeThis.treeItems.push(updateItem);
						}
						else
						{
							const parent = agile.getObjectById(scopeThis.treeItems, updateItem.editorMetaData.treeNodeParent);
							updateItem.parentItem = parent;
							parent.children.push(updateItem);
						}

						// Update sort order
						agile.updateTreeSortOrder(scopeThis.treeItems, tempActives);
						scopeThis.treeOpenNodes = tempActives;
						
						// Update tree
						// We need to tick one before we go go
						setTimeout(scopeThis.updateTreeDrag, 1);

					}, 1);
					
				}
				else
				{
					// Update sort order
					agile.updateTreeSortOrder(this.treeItems, this.treeOpenNodes);

					// Update tree
					// We need to tick one before we go go
					setTimeout(this.updateTreeDrag, 1);
				}

			}
			
		},
		
	},





	// --------------------------------------------------------------------
	//
	//	VUE: Destroy event hook
	//
	// --------------------------------------------------------------------

	beforeDestroy()
	{
		window.removeEventListener('resize', this.boundOnResize);

		// Remove all custom drag and drop listeners in tree view
		for (let i = this.trackedTreeNodes.length-1; i >= 0; i--)
		{
			this.removeDragAndDropListeners(this.trackedTreeNodes[i]);
		}
	},


}

</script>